<template>
    <div class="pc_page" id="pc_page">
        <!-- 活动标题 -->
        <div class="wechat-title" v-wechat-title="'《提灯与地下城》三周年庆典'"></div>

        <div class="top">
            <div class="logo"></div>
            <div class="btn_box">
                <div class="btn offical" @click="goLink('https://tideng.qingcigame.com/leading/')"></div>
                <div class="btn download" @click="goLink('https://tideng.qingcigame.com/leading/')"></div>
            </div>
        </div>
        <div class="slogan_box">
            <div class="slogan"></div>
            <div class="active_btn" @click="codeShow = true"></div>
        </div>

        <!-- 规则列表 -->
        <div class="rule_wrap popup_wrap_bg" v-show="codeShow" @click="closePopup('codeShow')">
            <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
                :duration="{ enter: 1000 }">
                <div class="detail_box">
                    <div class="detail">
                        <img class="swiper-lazy" src="https://download4.qcplay.com/h5-images/active/tideng/third/pc/pop.png" alt="详情">
                    </div>
                    <div class="close_btn" @click="closePopup('codeShow')"></div>
                </div>
            </transition>
        </div>
    </div>
</template>
<script>
import { getRandomString } from '@/utils/utils';
import { buriedLogger } from '@/utils/utils';
export default {
    name: 'anniversary',
    data() {
        return {
            codeShow: true,
            logger: null,
        }
    },
    created() {
        // 埋点
        const bl = buriedLogger('tideng', '提灯三周年庆典');
        this.logger = bl;
        var userAgent = navigator.userAgent.toLowerCase();
        var isPC = userAgent.indexOf('windows') > -1 || userAgent.indexOf('macintosh') > -1;
        if (isPC) {
            console.log('当前设备是 PC');
        } else {
            // this.logger.sum('提灯与地下城_三周年,PC');
            this.$router.push(`enter${getRandomString()}`);
            console.log('当前设备不是 PC');
        }
    },
    mounted() {
    },
    methods: {
        closePopup(name) {
            this[name] = false;
        },
        goLink(link) {
            this.logger.sum('提灯与地下城_三周年,PC前往官网');
            this.logger.sum('提灯与地下城_三周年,PC前往下载');
            window.location.href = link;
        }
    }
}
</script>
<style lang="less" scoped>
@import url("./pc.less");
</style>


// WEBPACK FOOTER //
// src/pages/tideng/third/pc/index.vue